import Vue from 'vue';

const promoActionRepository = {
    list: () => Vue.$axios.get('promos/actions')
        .then(({data}) => data, (error) => console.log(error)),
};

export default promoActionRepository;
